import React, { useState } from 'react';
import styled from 'styled-components';
import { Colors } from '../../constant/color';
import { Button, message } from 'antd';
import useSWR from 'swr';
import { UserApi, ValuationApi } from '../../apis';
import { getFinalizePolicy } from '../../constant/finalize-percent';
import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../navigation/type';
import { downloadPDF } from '../../utils';
import { Download } from 'lucide-react';

const BranchDirector = ({
  isBranchPercentConfirm = false,
}: {
  isBranchPercentConfirm?: boolean;
}) => {
  const { data: payload } = useSWR('swr.valuation.payload');
  const { data: me } = useSWR('/api/user/me', UserApi.me);
  const { canFinalize, canForward, forwardLabel } = getFinalizePolicy(me, payload?.percentBranchHead);
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [approvedVersion, setApprovedVersion] = useState<string>();
  const [downloading, setDownloading] = useState(false);
  const version = JSON.stringify([payload?.id, payload?.percentBranchHead, payload?.percentOdo, payload?.hasVat]);
  const approved = payload?.status === 'VALUATED' || approvedVersion === version;

  const onSubmit = async () => {
    if (approved || loading || (!canFinalize && !canForward)) return;
    try {
      messageApi.loading('Хүлээнэ үү...');
      setLoading(true);
      await ValuationApi.finalize({
        id: payload?.id,
        percentOdo: payload.percentOdo,
        percentBranchHead: payload.percentBranchHead,
        hasVat: payload?.hasVat,
      });
      if (canFinalize) setApprovedVersion(version);
      messageApi.destroy();
      messageApi.success('Амжилттай');
      if (canForward) navigate(NavigationRoutes.Valuation_ListScreen);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      messageApi.error(error?.message);
    }
  };

  const branchPercentConfirm = async () => {
    if (approved || loading || !canFinalize) return;
    try {
      messageApi.loading('Хүлээнэ үү...');
      setLoading(true);
      await ValuationApi.finalize({
        id: payload.id,
        percentOdo: payload.percentOdo,
        percentBranchHead: payload.percentBranchHead,
        hasVat: payload.hasVat || false,
      });
      await ValuationApi.branchPercentConfirm(payload.id);
      setApprovedVersion(version);
      messageApi.destroy();
      messageApi.success('Амжилттай');
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      messageApi.error(error?.message);
    }
  }

  const downloadReport = async () => {
    if (!approved || loading || downloading) return;
    setDownloading(true);
    try {
      const report = await ValuationApi.pdf(payload.id);
      downloadPDF(report.url);
    } catch (error: any) {
      messageApi.error(error?.message || 'PDF татахад алдаа гарлаа');
    } finally {
      setDownloading(false);
    }
  };

  if (
    !payload ||
    payload?.status === 'REJECTED' ||
    payload?.status === 'RETURNED' ||
    payload.status === 'DRAFT'
  ) {
    return <div></div>;
  }

  return (
    <>
      {contextHolder}
      <Container>
        <div className="h-[99px] w-[100%] absolute border z-[100] bottom-0 left-0 bg-[white] flex flex-row justify-end items-center pr-[21px] gap-[20px]">

          <Button
            type="primary"
            size="large"
            loading={downloading}
            disabled={!approved || loading}
            icon={<Download className="w-[20px] h-[20px]" />}
            onClick={downloadReport}
          >
            Тайлан татах
          </Button>

          <Button
            type="primary"
            size="large"
            loading={loading}
            onClick={isBranchPercentConfirm ? branchPercentConfirm : onSubmit}
            disabled={approved || downloading || (isBranchPercentConfirm ? !canFinalize : !canFinalize && !canForward)}
          >
            {!isBranchPercentConfirm && canForward ? forwardLabel : 'Батлах'}
          </Button>
        
        </div>
      </Container>
    </>
  );
};

const Container = styled.div`
  .ant-btn-color-primary {
    background-color: ${Colors.blue} !important;
  }
`;

export { BranchDirector };
